/* !! DO NOT EDIT manually, this file is AUTO-GENERATED. Any edits to the file will be overwritten during the build. Edits should be made to the SVG with a matching name */ import * as React from "react";
const SvgFluentIconPowerPoint = (props)=>/*#__PURE__*/ React.createElement("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 16 16",
        width: "1em",
        height: "1em",
        ...props
    }, /*#__PURE__*/ React.createElement("path", {
        d: "M8 0a8.024 8.024 0 0 0-8 8l10 2.363z",
        fill: "#ed6c47"
    }), /*#__PURE__*/ React.createElement("path", {
        d: "M8 0v8l4 2.59L16 8a8.024 8.024 0 0 0-8-8z",
        fill: "#ff8f6b"
    }), /*#__PURE__*/ React.createElement("path", {
        d: "M16 8A8 8 0 0 1 0 8z",
        fill: "#d35230"
    }), /*#__PURE__*/ React.createElement("path", {
        d: "M10 4.003H1.086A7.93 7.93 0 0 0 2.735 14h6.264a2 2 0 0 0 2-2V5.002a1 1 0 0 0-1-1z",
        opacity: 0.5
    }), /*#__PURE__*/ React.createElement("path", {
        d: "M10 4.003H1.086A7.93 7.93 0 0 0 2.735 14h6.264a2 2 0 0 0 2-2V5.002a1 1 0 0 0-1-1z",
        opacity: 0.1
    }), /*#__PURE__*/ React.createElement("rect", {
        y: 3,
        width: 10,
        height: 10,
        rx: 1,
        fill: "#c43e1c"
    }), /*#__PURE__*/ React.createElement("path", {
        d: "M5.336 5a2.276 2.276 0 0 1 1.56.481 1.766 1.766 0 0 1 .542 1.393 2.019 2.019 0 0 1-.267 1.042 1.827 1.827 0 0 1-.762.71 2.475 2.475 0 0 1-1.144.253H4.182V11h-1.11V5zM4.182 7.962h.956a1.2 1.2 0 0 0 .845-.265 1.009 1.009 0 0 0 .285-.777q0-.991-1.094-.991h-.992z",
        fill: "#fff"
    }));
export default SvgFluentIconPowerPoint;
